import UsersList from '../../../../../components/Users/List/UsersList';
import i18next from 'i18next';
import UserCreate from '../../../../../components/Users/Item/UserCreate';
import UserEdit from '../../../../../components/Users/Item/UserEdit';
import { ACCOUNT_ROUTES } from './account';

const USER_ROUTE_LIST_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/users',
  exact: true,
  parentRoute: ACCOUNT_ROUTES.listDS,
  additional: {
    component: UsersList,
    protected: true,
    title: i18next.t('titles:accountUsers'),
  },
};

const USER_ROUTE_CREATE_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/users/create',
  exact: true,
  parentRoute: USER_ROUTE_LIST_DS,
  additional: {
    component: UserCreate,
    protected: true,
    title: i18next.t('titles:createUser'),
  },
};

const USER_ROUTE_EDIT_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/users/:userUuid/edit',
  exact: true,
  parentRoute: USER_ROUTE_LIST_DS,
  additional: {
    component: UserEdit,
    protected: true,
    title: i18next.t('titles:editUser'),
  },
};

const USER_ROUTE_LIST = {
  path: '/:currentAccountUuid/users',
  exact: true,
  additional: {
    component: UsersList,
    protected: true,
    title: i18next.t('titles:accountUsers'),
  },
};

const USER_ROUTE_CREATE = {
  path: '/:currentAccountUuid/users/create',
  exact: true,
  parentRoute: USER_ROUTE_LIST,
  additional: {
    component: UserCreate,
    protected: true,
    title: i18next.t('titles:createUser'),
  },
};

const USER_ROUTE_EDIT = {
  path: '/:currentAccountUuid/users/:userUuid/edit',
  exact: true,
  parentRoute: USER_ROUTE_LIST,
  additional: {
    component: UserEdit,
    protected: true,
    title: i18next.t('titles:editUser'),
  },
};

export const USER_ROUTES = {
  // ------- For child accounts ------
  listDS: USER_ROUTE_LIST_DS,
  createDS: USER_ROUTE_CREATE_DS,
  editDS: USER_ROUTE_EDIT_DS,

  // ------- For current accounts ------
  list: USER_ROUTE_LIST,
  create: USER_ROUTE_CREATE,
  edit: USER_ROUTE_EDIT,
};
